import { combineReducers } from "redux";

import * as authActionTypes from "./auth/actionTypes";
import _notif from "./notification";
import _auth from "./auth";
import _catalogue from "./catalogue";
import _member from "./member";
import _admin from "./admin";

const appReducer = combineReducers({
  notif: _notif.reducer,
  auth: _auth.reducer,
  catalogue: _catalogue.reducer,
  member: _member.reducer,
  admin: _admin.reducer,
});

const rootReducer = (state, action) => {
  //Clear everything tied to the logged in user on logout (the public plans are kept)
  if (action.type === authActionTypes.LOGOUT) {
    return appReducer({ catalogue: state.catalogue, notif: state.notif }, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
